import React from "react";
import { FormItem, TextField } from "@tiny/components";
import { validateEmail } from "@tiny/components/src/utils/validateUtils";

interface EmailArrayValueProps {
  prefixName: string;
  disabled?: boolean;
}

function EmailArrayValue(props: EmailArrayValueProps) {
  const { prefixName, disabled } = props;

  const name = `${prefixName}.value.value`;

  return (
    <FormItem
      name={name}
      rules={{
        validate: validateEmails,
      }}
      watchValue
    >
      <EmailInput disabled={disabled} />
    </FormItem>
  );
}

interface EmailInputProps {
  value?: string[];
  onChangeValue?: (value: string[]) => void;
  helperText?: string;
  error?: boolean;
  inputRef?: React.ForwardedRef<HTMLInputElement>;
  disabled?: boolean;
}

function EmailInput(props: EmailInputProps) {
  const { value, onChangeValue, error, helperText, inputRef, disabled } = props;

  const fieldValue = value?.join(",");

  const changeValue = (v: string) => {
    const arr = v.split(",").map((item) => item.trim());
    onChangeValue?.(arr);
  };

  return (
    <TextField
      value={fieldValue}
      showHelperTextMargin
      placeholder="Add emails separated by commas"
      onChangeValue={changeValue}
      helperText={helperText}
      error={error}
      inputRef={inputRef}
      disabled={disabled}
    />
  );
}

function validateEmails(value: string[]) {
  if (!value || value.length === 0 || (value.length === 1 && !value[0])) {
    return "Required field";
  }
  for (let index = 0; index < value.length; index++) {
    const email = value[index];
    const error = validateEmail(email);
    if (error) {
      return error;
    }
  }
}

export default EmailArrayValue;
